import Pusher, { Channel } from "pusher-js";
import env from "../environment";

Pusher.logToConsole = false;

const pusher = new Pusher(env.REACT_APP_PUSHER_APP_KEY, {
  cluster: env.REACT_APP_PUSHER_APP_CLUSTER,
  channelAuthorization: {
    transport: "ajax",
    endpoint: `${env.REACT_APP_SERVER_API_URL}/pusher/auth`,
  },
});

/**
 * @example
 * useRealtimeChannel("my-channel", ["my-event"], (event, data) => {
 *   console.log(event, data);
 * })
 */
const useRealtimeChannel = () => {
  const subscribe = (channelName: string, eventNames: string[], callback: (event: string, data: any) => void) => {
    const channel = pusher.subscribe(channelName);

    eventNames.forEach((eventName) => {
      channel.bind(eventName, (data: any) => callback(eventName, data));
    });

    return channel;
  };

  const unsubscribe = (channel: Channel, channelName: string) => {
    channel.unbind_all();
    pusher.unsubscribe(channelName);
  };

  return {
    unsubscribe,
    subscribe,
  };
};

export default useRealtimeChannel;
